module.exports = __webpack_public_path__ + "fonts/StyreneAWeb-MediumItalic.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/StyreneAWeb-MediumItalic.ttf
// module id = 82
// module chunks = 8